import styles from './style.mod.scss';
import React from 'react';
import { Body } from 'scy/text';
import ToolTipWrapper from '../ui/toolTip';
import { secondary } from 'scy/text/styles.mod.scss';
import { capitalize } from 'shared/utils';
import IconContainer from '../checkoutPage/form/IconContainer';
import ArrowUpIcon from 'images/icons/arrow-up-round-up.svg?react-svg';
import { AccentH5, SecondaryH6 } from 'scy/text';
import { uppercase } from 'scy/text/styles.mod.scss';
import { flex, row, spaceBetween } from 'scy/flex.mod.scss';
import classnames from 'classnames';
import padding from 'scy/padding.mod.scss';

const Icon = () => {
  return (
    <IconContainer>
      <ArrowUpIcon width={20} />
    </IconContainer>
  );
};

const Title = ({ showRoundUpStatement, setshowRoundUpStatement }) => {
  return (
    <Body style={{ position: 'relative' }}>
      <ToolTipWrapper
        dataFor="round up"
        type="light"
        delayHide={500}
        clickable={true}
        hoverText="You can turn off Rounding Up at any time here or in your profile
          settings. When Round Up is on, we will round your total to the nearest
          dollar, donating the change to furthering social justice work."
      >
        <span className={styles.round_up_info_icon} data-tip="round up">
          i
        </span>
      </ToolTipWrapper>
      <AccentH5 tag="h2" className={(uppercase, padding.bottom_xs)}>
        BE THE CHANGE, ROUND UP.
      </AccentH5>
      <SecondaryH6
        className={classnames(
          secondary,
          padding.bottom_sm,
          styles.letter_spacing_1
        )}
      >
        Pick an organization, donate the change.
      </SecondaryH6>
      <AccentH5
        onClick={() => setshowRoundUpStatement(!showRoundUpStatement)}
        style={{ cursor: 'pointer' }}
      >
        Why these orgs?
        <span
          className={classnames(
            styles.chevron,
            !showRoundUpStatement && styles.bottom
          )}
        />
      </AccentH5>
      {showRoundUpStatement && (
        <>
          <SecondaryH6
            className={classnames(
              secondary,
              padding.top_sm,
              styles.letter_spacing_1
            )}
          >
            Injustice anywhere is a threat to justice everywhere.
          </SecondaryH6>
          <SecondaryH6
            className={classnames(
              secondary,
              padding.top_sm,
              styles.letter_spacing_1
            )}
          >
            We believe it’s important to champion equity, fight for social
            justice in the world we inhabit and we know that we can start right
            here, right now with a commitment to do so as long as our lights are
            on.
          </SecondaryH6>
          <SecondaryH6
            className={classnames(
              secondary,
              padding.top_sm,
              styles.letter_spacing_1
            )}
          >
            Just saying so, is not enough. So we are giving and asking you to
            join us, in keeping this work funded. That’s why we carefully chose
            organizations doing the necessary and important labor, on multiple
            fronts - from legislation to community care and more, daily.
          </SecondaryH6>
        </>
      )}
    </Body>
  );
};

const RoundUpRowCollapsed = ({
  children,
  showRoundUpStatement,
  setshowRoundUpStatement
}) => {
  return (
    <div className={classnames(flex, row, spaceBetween, {})}>
      <div className={classnames(flex, row)}>
        <Icon />
        <Title
          showRoundUpStatement={showRoundUpStatement}
          setshowRoundUpStatement={setshowRoundUpStatement}
        />
      </div>
      {typeof children === 'string' ? capitalize(children) : children}
    </div>
  );
};

export default RoundUpRowCollapsed;
